






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
  data() {
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
        },
        content: {
          name: "Quản lý phòng",
          urlEnabled: true,
          search: {},
          filters: {
            filters: {
              disabled: {
                type: "select",
                attrs: {
                  label: "Trạng thái",
                  items: [
                    { text: "Hoạt động", value: false },
                    { text: "Dừng hoạt động", value: true },
                  ],
                },
                rules: {
                  equal_to: {},
                },
              },
            },
          },
          displayFields: {
            index: {
              text: "STT",
              options: {
                index: true,
              },
            },
            name: {
              text: "Tên",
              sortable: true,
            },
            description: {
              text: "Mô tả",
              sortable: true,
            },
            disabled: {
              text: "Trạng thái",
              options: {
                label(value) {
                  return (value && "Dừng hoạt động") || "Hoạt động";
                },
                attrs(value) {
                  return {
                    color: value ? "red" : "green",
                  };
                },
              },
            },
            tmdt: {
              text: "TMDT",
              sortable: true,
              options: {
                boolean: true,
              },
            },
            parentDepartment: {
              text: "Phòng cha",
              options: {
                subProp: "parentDepartment.name",
                label: true,
                sortBy: "parentDepartmentId",
              },
            },
            avgTvDuration: {
              text: "Thời gian thử việc trung bình",
              options: {
                preTransform(value) {
                  if (value) {
                    const duration = Math.floor(value / 86400 / 1000);
                    return `${duration} ngày`;
                  }
                },
              },
            },
            createdTime: {
              text: "Ngày tạo",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {},
          },
          findAllOptionsFilter(options) {
            options.orderItems = [];
            options.orderItems.push({
              field: "disabled",
              type: "asc",
            });
            if (options.orderBy) {
              options.orderItems.push({
                field: options.orderBy,
                type: options.orderType,
              });
              options.orderBy = undefined;
              options.orderType = undefined;
            }
            return options;
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["kt"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("departments", "findAll", options);
              if (items.length) {
                const ids = items.map((item) => item._id);
                const avgTvDurations = await coreApiClient.call("users", "getStatistic", {
                  payload: JSON.stringify({
                    findRequest: {
                      filters: [
                        {
                          key: "departmentId",
                          operator: "in",
                          value: ids,
                        },
                        {
                          key: "tvTime",
                          operator: "greater_than",
                          value: 0,
                        },
                        {
                          key: "ctTime",
                          operator: "greater_than",
                          value: 0,
                        },
                      ],
                    },
                    aggregations: {
                      departments: {
                        type: "terms",
                        magicFields: {
                          id: "departmentId",
                        },
                        subAggregations: {
                          avg: {
                            type: "avg",
                            magicField: {
                              funcName: "subtract",
                              fields: ["ctTime", "tvTime"],
                            },
                          },
                        },
                      },
                    },
                  }),
                });
                return [
                  items.map((item) => {
                    const departmentInfo = avgTvDurations.departments[item._id];
                    if (departmentInfo && departmentInfo.info && departmentInfo.info.avg) {
                      item.avgTvDuration = departmentInfo.info.avg;
                    }
                    return item;
                  }),
                  count,
                ];
              }
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("departments", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "departments",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("departments", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Tên",
                  required: true,
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              disabled: {
                type: "select",
                attrs: {
                  label: "Trạng thái",
                  items: [
                    { text: "Hoạt động", value: false },
                    { text: "Dừng hoạt động", value: true },
                  ],
                },
              },
              tmdt: {
                type: "boolean",
                attrs: {
                  label: "TMDT",
                },
              },
              parentDepartmentId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Phòng",
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsLoader() {
                        const { items } = await coreApiClient.call("departments", "findAll", {
                          limit: -1,
                        });
                        return items;
                      },
                    },
                  },
                },
              },
            },
            insertForm: userManager.checkRole(["kt"]) && {
              content: {
                fieldNames: ["name", "description", "disabled", "tmdt", "parentDepartmentId"],
              },
            },
            editForm: userManager.checkRole(["kt"]) && {
              content: {
                fieldNames: ["name", "description", "disabled", "tmdt", "parentDepartmentId"],
              },
            },
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
});
